import styled from 'styled-components';

export const WalletSelectDetails = styled.p`
  font-size: 0.85rem;
  opacity: 0.7;
  margin-top: 4px;
`;
